import { Event as EventModel } from '@/models/Event';
import { Timeslot } from '@/models/Timeslot';
import { DateTime } from 'luxon';
import { DateTimeslot } from '@/models/DateTimeslot';
// Parse Events to Calendar Events
export const parseToCalendarEvents = (events) => {
    const parsed = [];
    events.forEach((event) => {
        parsed.push(event.calendarEvent);
    });
    return parsed;
};
// // Parse DateTimeslot to Calendar Events
// export const parseDateTimeslotsToCalendarEvents = (timeslots: DateTimeslotSummary[]) => {
//   let parsed:any[] = [];
//   timeslots.forEach((timeslot: DateTimeslotSummary) => {
//     parsed.push(timeslot.calendarEvent);
//   });
//   return parsed;
// }
// Parse Timeslot to Calendar Events
export const parseTimeslotsToCalendarEvents = (timeslots, currentWeek) => {
    const parsed = [];
    timeslots.forEach((timeslot) => {
        const calendarEvent = parseTimeslotsToCalendarEvent(timeslot, currentWeek);
        parsed.push(calendarEvent);
    });
    return parsed;
};
export const parseTimeslotsToCalendarEvent = (timeslot, currentWeek) => {
    const calendarEvent = timeslot.calendarEvent;
    calendarEvent.start = `${currentWeek[timeslot.day || '']}T${timeslot.starts_at}`;
    calendarEvent.end = `${currentWeek[timeslot.day || '']}T${timeslot.ends_at}`;
    return calendarEvent;
};
// Parse Calendar Event to Timeslot Model
export const parseToTimeslotModel = (eventInfo, type = 'timeslot', templateId = '') => {
    const event = new Timeslot({
        day: DateTime.fromJSDate(eventInfo.start).toFormat('c'),
        starts_at: DateTime.fromJSDate(eventInfo.start).toFormat('yyyy-LL-dd HH:mm:ss'),
        ends_at: DateTime.fromJSDate(eventInfo.end).toFormat('yyyy-LL-dd HH:mm:ss'),
        type,
        title: eventInfo.title ? eventInfo.title : '',
        id: eventInfo.id || (eventInfo.event && eventInfo.event.id) || '',
        template: templateId,
    });
    return event;
};
// Parse Calendar Event to Event Model
export const parseToEventModel = (eventInfo, type = 'other') => {
    const event = new EventModel({
        starts_at: DateTime.fromJSDate(eventInfo.start).toFormat('yyyy-LL-dd HH:mm:ss'),
        ends_at: DateTime.fromJSDate(eventInfo.end).toFormat('yyyy-LL-dd HH:mm:ss'),
        type,
        title: eventInfo.title ? eventInfo.title : '',
        id: eventInfo.id || '',
    });
    return event;
};
// Parse Calendar Event to DateTimeslot Model
export const parseToDateTimeslotModel = (eventInfo, type = 'timeslot', templateId = '') => {
    const event = new DateTimeslot({
        day: DateTime.fromJSDate(eventInfo.event.start).toFormat('c'),
        starts_at: DateTime.fromJSDate(eventInfo.event.start).toFormat('yyyy-LL-dd HH:mm:ss'),
        ends_at: DateTime.fromJSDate(eventInfo.event.end).toFormat('yyyy-LL-dd HH:mm:ss'),
        type,
        title: eventInfo.event.title ? eventInfo.event.title : '',
        id: eventInfo.event.id || '',
        template: templateId,
    });
    return event;
};
